/** URL param value for aggregate (all Barchart watchlists) under Holdings. */
export const BARCHART_WATCHLIST_ALL = "all";

export function isBarchartWatchlistAggregate(watchlistId) {
  return watchlistId == null || watchlistId === "" || watchlistId === BARCHART_WATCHLIST_ALL;
}
